const AccountTypes = ['bundid', 'passkey', 'totp', 'muk', 'pwd'];
export const isSupportedAccountType = (t) => {
    return AccountTypes.includes(t);
};
